import { useEffect } from "react";
import moment from "moment";
import { useGetSanctuaryLiteEntriesMutation } from "../../store/services/sanctuaryLite";

const SanctuaryLite = () => {
  const [getEntries, { data }] = useGetSanctuaryLiteEntriesMutation();

  useEffect(() => {
    getEntries("");
  }, []);

  return (
    <main className="w-full bg-white flex-col flex p-10">
      <div className="filters w-full relative my-2">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold">Sanctuary Lite Early Access</h1>
        </div>
      </div>
      <table className="border-collapse rounded-xl overflow-hidden">
        <tbody>
          <tr className="bg-black divide-x text-white  border ">
            <th className="py-2">Full Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Country</th>
            <th>City</th>
            <th>Space</th>
            <th>Company Name</th>
            <th>About Their Space</th>
            <th>Registered At:</th>
          </tr>
          {data &&
            data.length > 0 &&
            data.map((val) => {
              return (
                <tr key={val._id} className="text-center border-t border-gray-200 divide-x ">
                  <td className="py-1">{val.fullName}</td>
                  <td>{val.emailId}</td>
                  <td>{val.phoneNumber}</td>
                  <td>{val.country}</td>
                  <td>{val.city}</td>
                  <td>{val.space}</td>
                  <td>{val.companyName}</td>
                  <td className="text-left px-2 whitespace-pre-line">{val.tellUsAboutUrSpace}</td>
                  <td>{val.saved_at && moment(val.saved_at).format("DD-MM-YYYY HH:mm")}</td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </main>
  );
};

export default SanctuaryLite;
